import { rankingItems } from '@/mocks/home-data';

export default function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400"></i>;
    return <i className="ri-subtract-line text-foreground-400"></i>;
  };

  const getRankBadge = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-secondary-500 text-background-50';
    if (rank === 3) return 'bg-secondary-400 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          人气排行
        </h2>
        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 bg-background-50 border border-background-200/70 rounded-xl mb-3 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankBadge(item.rank)}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-foreground-950">{item.title}</h3>
                <div className="text-xs text-foreground-500">{item.category}</div>
              </div>
              <div className="flex items-center gap-1.5">
                {getTrendIcon(item.trend)}
                <span
                  className={`text-xs font-medium ${
                    item.change.startsWith('+')
                      ? 'text-primary-500'
                      : item.change === '—'
                        ? 'text-foreground-400'
                        : 'text-foreground-400'
                  }`}
                >
                  {item.change}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
                <span className="text-sm font-bold text-accent-600">{item.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}